// extracted by mini-css-extract-plugin
export var box = "_64-0";
export var check = "_64-1";
export var checkboxButton = "_64-6";
export var checkboxGroup = "_64-5";
export var disabled = "_64-7";
export var ghost = "_64-9";
export var input = "_64-2";
export var label = "_64-4";
export var normal = "_64-8";
export var uncheck = "_64-3";